import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const newYearGetOptions = () => axiosInstance.get('/settings/get-new-year-settings', { params: pickDevParams });

export const newYearSaveOptions = (data) => axiosInstance.post('/settings/save-new-year-settings', { data, ...pickDevParams });

export const newYearActivate = () => axiosInstance.post('/settings/activate-new-year-settings', pickDevParams);

export const newYearDeactivate = () => axiosInstance.post('/settings/deactivate-new-year-settings', pickDevParams);
